'use client';
import { type Brand } from '@curology/ui-components-web/brand';
import { HelpIcon } from '@curology/ui-components-web/react/Icon/icons/HelpIcon';
import { LogoutIcon } from '@curology/ui-components-web/react/Icon/icons/LogoutIcon';
import { NavigationItem } from '@curology/ui-components-web/react/Navigation/NavigationItem';

import { AnalyticsEvent, trackEvent } from '@/utils/analytics';
import { flushFeatureTracking } from '@/utils/featureFlags/client';
import { urls } from '@/utils/urls';

const supportLinkMap: Record<Brand, string> = {
  curology: 'https://support.curology.com/curology-success-team-Sk9Umh_hd',
  agency: 'https://curology-agency.kustomer.help/contact/contact-us-SJA95gPc_',
};

export const LoggedInControls = ({ brand }: { brand: Brand }) => (
  <div className="cur-flex">
    <NavigationItem
      data-sentry-id="Help link"
      href={supportLinkMap[brand]}
      target="_blank"
      className="cur-cursor-pointer cur-px-0"
    >
      <HelpIcon size="sm" />
    </NavigationItem>
    <NavigationItem
      data-sentry-id="Log out link"
      onClick={() => {
        trackEvent(AnalyticsEvent.LOGOUT);

        flushFeatureTracking(() => {
          window.location.assign(urls[brand].legacy.auth.logout);
        });
      }}
      className="cur-cursor-pointer"
    >
      <LogoutIcon size="sm" />
    </NavigationItem>
  </div>
);
